const sessionAliases = new Map();

const generateNumericSuffix = () => {
    const maxExclusive = 1000;

    if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
        const limit = Math.floor(0x100000000 / maxExclusive) * maxExclusive;
        const buffer = new Uint32Array(1);
        // eslint-disable-next-line no-constant-condition
        while (true) {
            window.crypto.getRandomValues(buffer);
            const value = buffer[0];
            if (value < limit) {
                return String(value % maxExclusive);
            }
        }
    }

    return String(Math.floor(Math.random() * maxExclusive));
};

export const getPostAliasKey = (post) => {
    if (!post || typeof post !== 'object') {
        return null;
    }

    const author = typeof post.author === 'string' ? post.author.trim() : '';
    if (author) {
        return `author:${author.toUpperCase()}`;
    }

    return (
        post._id ||
        post.id ||
        post.documentNumber ||
        post.copyNumber ||
        (post.title || post.date ? `${post.title ?? ''}|${post.date ?? ''}` : null)
    );
};

export const getLaymenAuthorLabel = (post, { prefix = 'Layman ' } = {}) => {
    const key = getPostAliasKey(post);
    if (!key) {
        return `${prefix}${generateNumericSuffix()}`;
    }

    const cached = sessionAliases.get(key);
    if (cached) {
        return `${prefix}${cached}`;
    }

    const suffix = generateNumericSuffix();
    sessionAliases.set(key, suffix);
    return `${prefix}${suffix}`;
};
